import { Link, useLocation } from "react-router-dom";

import PageHeader from "components/PageHeader";
import StatsFilterBar from "./StatsFilterBar";
import "./workforce.css";

export const TABS = [
  { key: "overview", label: "Overview" },
  { key: "turnover", label: "Turnover & retention" },
];

export const currentTab = (search) => {
  const tab = new URLSearchParams(search).get("tab");
  return TABS.some((t) => t.key === tab) ? tab : "overview";
};

/** Same page, two tabs, chosen by `?tab=`. The sidebar entry and route stay
 *  exactly as before; switching tab keeps the cost center/department filters
 *  because only the `tab` parameter changes. */
const StatsShell = ({ subtitle, filterProps, showPeriod, children }) => {
  const { pathname, search } = useLocation();
  const active = currentTab(search);
  const hrefFor = (key) => {
    const params = new URLSearchParams(search);
    if (key === "overview") params.delete("tab");
    else params.set("tab", key);
    const query = params.toString();
    return query ? `${pathname}?${query}` : pathname;
  };

  return (
    <div className="page-wrapper">
      <div className="content container-fluid ws-page">
        <PageHeader title="Employee Statistics" subtitle={subtitle}>
          <nav className="ws-tabs" aria-label="Employee statistics views">
            {TABS.map((tab) => (
              <Link
                key={tab.key}
                to={hrefFor(tab.key)}
                replace
                className={`ws-tab${active === tab.key ? " is-active" : ""}`}
                aria-current={active === tab.key ? "page" : undefined}
              >
                {tab.label}
              </Link>
            ))}
          </nav>
          <StatsFilterBar {...filterProps} showPeriod={showPeriod} />
        </PageHeader>
        {children}
      </div>
    </div>
  );
};

export default StatsShell;
